module.exports = __webpack_public_path__ + "img/MOAC.60047f3f.svg";